module.exports = __webpack_public_path__ + "_/node_modules/@catalytic/pushbot-ui-xtras/assets/fonts/NotoSansUI-BoldItalic.woff?d8a9bb51a88bc56333be65a347eadbfa]";


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui-xtras/assets/fonts/NotoSansUI-BoldItalic.woff
// module id = 1883
// module chunks = 32